import { makeStyles } from 'tss-react/mui';

export const useCopyOrderModalStyles = makeStyles()((theme) => ({
  invalidChip: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.main,
  },
}));
